import React from 'react';
import PropTypes from 'prop-types';
import postal from 'postal';
import ErrorBoundary from '../../shared/error-boundary';

export default function EditorsPickButton(props) {
  function pick(event) {
    event && event.preventDefault();

    postal.publish({
      channel: 'commands.editors-picks',
      topic: 'pick-wire',
      data: { wire: props.wire },
    });
  }

  return (
    <ErrorBoundary>
      <button type="button" className="btn btn-secondary" onClick={pick}>Pick</button>
    </ErrorBoundary>
  );
}

EditorsPickButton.propTypes = {
  wire: PropTypes.shape({
    wire_id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    wire: PropTypes.objectOf(PropTypes.object).isRequired,
  }).isRequired,
};
